/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/public/js";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	/* global enquire, global, turnOffBigDocTableWrapper (from episerver) */
	
	window.stortinget = window.stortinget || {};
	
	window.stortinget.initializeSocialButton = function (e) {
	    e.preventDefault();
	
	    var $trigger = $(e.target);
	    var $target = $("[data-social-selector]", $(e.target).parent());
	
	    $trigger.toggleClass("active");
	    $trigger.attr("aria-expanded", $trigger.hasClass("active") ? "true" : "false");
	
	    $target.animate({
	        height: 'toggle',
	        'padding-top': 'toggle',
	        'padding-bottom': 'toggle'
	    });
	};
	
	(function ($) {
	    // Table wrapper function
	    $.fn.tablewrapper = function (options) {
	        var tbl = this,
	            settings = $.extend({
	            textclosed: "Vis tabellen under i full bredde",
	            textopen: "Skjul overflytende tabell innhold"
	        }, options),
	            $init = function $init() {
	            if ($(window).width() >= 1024) {
	                $(".header-container").find("a").each(function (e) {
	                    if ($(this).attr("tabindex") != "0") $(this).removeAttr("tabindex");
	                });
	                $(".header-container").find("button").each(function (e) {
	                    if ($(this).attr("tabindex") != "0") $(this).removeAttr("tabindex");
	                });
	                $(".close-wrapper").find("button").each(function (e) {
	                    if ($(this).attr("tabindex") != "-1") ;
	                    $(this).prop("tabindex", -1);
	                });
	            }
	
	            return tbl.each(function () {
	                var t = $(this),
	                    telm = t.parent();
	
	                if (t.width() > telm.width() && !t.parent().parent().hasClass("tblwrp-wrapper")) {
	                    t.wrap('<div class="tblwrp-wrapper" data-tblwrp-wrapper></div>');
	                    t.after('<div class="tblwrp-fader" data-tblwrp-fader></div>');
	                    t.wrap('<div class="tblwrp-scrollarea" data-tblwrp-scrollarea></div>');
	                }
	
	                var wrapper = t.closest("[data-tblwrp-wrapper]"),
	                    welm = wrapper.parent();
	
	                if (!wrapper.hasClass("tblwrp-minified") && t.width() > welm.width() && wrapper.data("tblwrp-opened-by-user") !== "true") {
	                    wrapper.addClass("tblwrp-minified");
	
	                    if (!wrapper.prev().is("[tblwrp-wrapper-trigger]")) {
	                        wrapper.before('<button type="button" class="tblwrp-wrapper-trigger" tblwrp-wrapper-trigger data-tblwrp-closed-text="' + settings.textclosed + '" data-tblwrp-open-text="' + settings.textopen + '" role="presentation">' + settings.textclosed + "</button>");
	                    }
	                } else if (t.width() <= welm.width()) {
	                    wrapper.prev("[tblwrp-wrapper-trigger]").remove();
	                    wrapper.removeClass("tblwrp-minified");
	                    t.next("[data-tblwrp-fader]").remove();
	                    t.unwrap().unwrap();
	                }
	            });
	        };
	
	        $init();
	        $(window).on("afterresize", function () {
	            $init();
	        });
	
	        $(document).on("click", "[tblwrp-wrapper-trigger]", function () {
	            var trggr = $(this),
	                wrpr = trggr.next("[data-tblwrp-wrapper]");
	
	            if (wrpr.hasClass("tblwrp-minified")) {
	                wrpr.data("tblwrp-opened-by-user", "true");
	                wrpr.removeClass("tblwrp-minified");
	                trggr.text(trggr.data("tblwrp-open-text"));
	            } else {
	                wrpr.removeAttr("tblwrp-opened-by-user");
	                wrpr.addClass("tblwrp-minified");
	                trggr.text(trggr.data("tblwrp-closed-text"));
	            }
	        });
	    };
	
	    // Table wrapper function for (big) documents
	    $.fn.tablewrapperBigdoc = function (options) {
	        var $tbl = this,
	            $settings = $.extend({
	            textclosed: "Vis tabellen i full bredde"
	        }, options),
	            $init = function $init() {
	            var $tableCount = 0;
	            $tbl.each(function () {
	                $tableCount++;
	
	                var $table = $(this),
	                    $tableWidth = $table.width();
	
	                if (!$table.parent().hasClass("tablewrapper") && !$table.parent().hasClass("tblwrp-scrollarea")) {
	                    $table.wrap('<div class="tablewrapper" data-table-id="' + $tableCount + '"></div>');
	                }
	
	                var $twrap = $('[data-table-id="' + $tableCount + '"]');
	                if ($twrap.width() < $tableWidth) {
	                    if (!$twrap.prev().hasClass("btn-zoom")) {
	                        $table.after('<div class="tablewrapper-fader"></div>');
	                        $twrap.before('<button class="btn-zoom icon-search icon-left" aria-haspopup="true" data-btn-zoom-table>' + $settings.textclosed + "</button>");
	                        $twrap.addClass("wide-table");
	                    }
	                } else if ($twrap.width() >= $tableWidth) {
	                    $table.next(".tablewrapper-fader").remove();
	                    $twrap.prev("[data-btn-zoom-table]").remove();
	                    $twrap.removeClass("wide-table");
	                }
	            });
	        };
	
	        $init();
	        $(window).on('afterresize', function () {
	            $init();
	        });
	
	        var $zoomFocusElem,
	            $focusableElems = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";
	
	        function trapTabKey(obj, e) {
	            // if TAB or SHIFT-TAB pressed, keep focus on focuable elements within the lightbox
	            if (e.which === 9) {
	                var o = obj.find("*"),
	                    focusableItems,
	                    focusedItem,
	                    numberOfFocusableItems,
	                    focusedItemIndex;
	
	                focusableItems = o.filter($focusableElems).filter(":visible");
	                focusedItem = jQuery(":focus");
	                numberOfFocusableItems = focusableItems.length;
	                focusedItemIndex = focusableItems.index(focusedItem);
	
	                if (e.shiftKey) {
	                    // Back tab - if focused on first item and user preses back-tab, go to the last focusable item
	                    if (focusedItemIndex === 0) {
	                        focusableItems.get(numberOfFocusableItems - 1).focus();
	                        e.preventDefault();
	                    }
	                } else {
	                    // Forward tab - if focused on the last item and user preses tab, go to the first focusable item
	                    if (focusedItemIndex === numberOfFocusableItems - 1) {
	                        focusableItems.get(0).focus();
	                        e.preventDefault();
	                    }
	                }
	            }
	        }
	
	        var lightboxAvoidWhiteSpace = function lightboxAvoidWhiteSpace() {
	            var lbox = $("[data-zoom-lightbox] > .tablewrapper-lightbox");
	            if (lbox.length) {
	                if ($("[data-zoom-table]").height() + 180 > $(window).height()) {
	                    lbox.css("bottom", "10px");
	                } else {
	                    lbox.css("bottom", "auto");
	                }
	            }
	        };
	
	        $(document).on("click", "[data-btn-zoom-table]", function (e) {
	            var $tablew = $(this).next(),
	                $src = $tablew.html(),
	                $lghtbx = '<div class="tablewrapper-lightbox-wrapper" role="dialog" data-zoom-lightbox><div class="tablewrapper-lightbox"><div class="tablewrapper-lightbox-inner" tabindex="0" data-zoom-table>' + $src + '</div><button class="close-lightbox close-button" data-close-lightbox>Lukk</button></div></div>';
	
	            $("body").append($lghtbx).addClass("lightbox-open").attr("aria-hidden", "true");
	            $("[data-zoom-lightbox]").fadeIn("fast", function () {
	                lightboxAvoidWhiteSpace();
	                $("[data-zoom-table]").focus();
	            });
	
	            $zoomFocusElem = $(this);
	
	            e.preventDefault();
	        });
	
	        $(window).on("resize", function () {
	            lightboxAvoidWhiteSpace();
	        });
	
	        $(document).on("click", "[data-close-lightbox]", function () {
	            $("body").removeClass("lightbox-open").attr("aria-hidden", "false");
	            $("[data-zoom-lightbox]").fadeOut("fast", function () {
	                $("[data-zoom-lightbox]").remove();
	            });
	            $zoomFocusElem.focus();
	        }).on("keydown", "[data-zoom-lightbox]", function (e) {
	            if (e.which === 27) {
	                $("body").removeClass("lightbox-open").attr("aria-hidden", "false");
	                $("[data-zoom-lightbox]").fadeOut("fast", function () {
	                    $("[data-zoom-lightbox]").remove();
	                });
	                $zoomFocusElem.focus();
	            } else {
	                trapTabKey($(this), event);
	            }
	        }).on("click", "[data-zoom-lightbox]", function (e) {
	            $("[data-zoom-lightbox]").fadeOut("fast", function () {
	                $("[data-zoom-lightbox]").remove();
	            });
	            $("body").removeClass("lightbox-open").attr("aria-hidden", "false");
	        }).on("click", ".zoom-lightbox", function (e) {
	            e.stopPropagation();
	        });
	    };
	
	    /*
	     * Modified version of the jQuery afterresize event plugin
	     *   Copyright (c) 2010 Visa Kopu, visa@visakopu.net
	     *   Licensed under the BSD license.
	     *   http://github.com/roxeteer/jquery-afterresize/wiki/License
	     */
	    var resizeHandler = function resizeHandler() {
	        var el = $(this);
	
	        if (el.data("resizetimer")) {
	            window.clearTimeout(el.data("resizetimer"));
	        }
	
	        el.data("resizetimer", window.setTimeout(function () {
	            el.trigger("afterresize");
	        }, 300));
	    };
	
	    $.event.special.afterresize = {
	        add: function add(handleObj) {
	            $(this).on("resize", resizeHandler);
	
	            var old_handler = handleObj.handler;
	            handleObj.handler = function () {
	                return old_handler.apply(this, arguments);
	            };
	        },
	
	        remove: function remove() {
	            $(this).off("resize", resizeHandler);
	        }
	    };
	
	    $.fn.extend({
	        afterresize: function afterresize(f) {
	            if ($.isFunction(f)) {
	                $(this).on("afterresize", f);
	            } else {
	                $(this).trigger("afterresize");
	            }
	
	            return this;
	        }
	    });
	})(window.jQuery);
	//import enquire from '../../public/js/vendor/enquire.min.js';
	
	// Avoid `console` errors in browsers that lack a console.
	(function () {
	    var method;
	    var noop = function noop() {};
	    var methods = ["assert", "clear", "count", "debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed", "groupEnd", "info", "log", "markTimeline", "profile", "profileEnd", "table", "time", "timeEnd", "timeStamp", "trace", "warn"];
	    var length = methods.length;
	    var console = window.console = window.console || {};
	
	    while (length--) {
	        method = methods[length];
	
	        // Only stub undefined methods.
	        if (!console[method]) {
	            console[method] = noop;
	        }
	    }
	})();
	
	$(function () {
	    window.scope = "small";
	    var isOpera = window.opera !== undefined ? true : false;
	    var openTab = false;
	
	    var app = function () {
	        "use strict";
	
	        return {
	            init: function init() {
	                var global = this;
	
	                // Lock body on nav open - START
	                app.$htmlBody = $("html, body");
	                app.$wrap = $("#app");
	                app.scrollTop;
	                // Lock body on nav open - END
	
	                var smallOnlyMQ = "screen and (max-width: 40em)",
	                    mediumOnlyMQ = "screen and (min-width: 40.063em) and (max-width: 63.9375em)",
	                    //64em
	                largeDownMQ = "screen and (max-width: 63.9375em)",
	                    largeUpMQ = "screen and (min-width: 64em)",
	                    //64.063em
	                small = {
	                    match: function match() {
	                        scope = "small";
	                        global.masonry("destroy");
	                    },
	                    unmatch: function unmatch() {}
	                },
	                    medium = {
	                    match: function match() {
	                        scope = "medium";
	                        global.masonry();
	                    },
	                    unmatch: function unmatch() {}
	                },
	                    largeDown = {
	                    setup: function setup() {
	                        global.navPrimary("small");
	                        //global.toggleSearch();
	                        global.toggleNavPrimary();
	                        global.toggleSearch();
	                    },
	                    unmatch: function unmatch() {
	                        global.scopeChanged();
	                    }
	                },
	                    large = {
	                    setup: function setup() {
	                        global.toggleLanguage();
	                        global.toggleSocial();
	                        global.navPrimary("large");
	                        global.toggleSearch();
	                    },
	                    match: function match() {
	                        scope = "large";
	                        global.masonry();
	
	                        // global.adjustMainBlockArrowDesktop();
	                    },
	                    unmatch: function unmatch() {
	                        // check if mobile search open
	                        if ($(".main-container").hasClass("mobile-search-open")) {
	                            // close nav
	                            $('[data-toggler="search-container"]').trigger("click");
	                        }
	
	                        // check if desktop open
	                        if ($(".nav-primary > ul > li").hasClass("active")) {
	                            $(".nav-primary > ul > li.active a").trigger("click");
	                        }
	
	                        global.scopeChanged();
	                    }
	                };
	
	                enquire.register(smallOnlyMQ, small);
	                enquire.register(mediumOnlyMQ, medium);
	                enquire.register(largeDownMQ, largeDown);
	                enquire.register(largeUpMQ, large);
	
	                global.zoomArticleImage();
	                global.imageCaptionWidth();
	                global.caseScroll();
	                global.accessifly();
	                global.dataToggle();
	                global.dataTabs();
	                global.dataTabsShadow();
	                global.dataTabButtonList();
	                global.dataHide();
	                global.dataTriggerClick();
	                global.customFileUpload();
	                global.fullVideoPlayerAdaption();
	                global.wrapVideoIframe();
	                global.greyboxAlignHeight();
	                global.setLanguageCookieOnSelect();
	                global.tableWrap();
	                global.copyStringToClipboard();
	                if (!window.turnOffBigDocTableWrapper) global.tableWrapBigdoc(); // this one causing trouble
	                global.addHashToShareLinks();
	
	                $(window).on("load resize", function () {
	                    var $ajaxblock = $(".block-main .block-main-ajax"),
	                        $mediablockimg = $(".block-main-media img");
	
	                    if ($ajaxblock.length && $mediablockimg.length) {
	                        if ($(window).width() >= 1024) {
	                            $ajaxblock.css("max-height", Math.round($mediablockimg.height() - 120));
	                        } else {
	                            $ajaxblock.removeAttr("style");
	                        }
	                    }
	                });
	
	                $(document).ready(function () {
	                    global.scrollPageIfMobileAndAnchorLink();
	                    global.addHashScrollToHrefsIfStickyHeader();
	                });
	
	                $(".toggle-details").on("click", function (e) {
	                    e.preventDefault();
	                    $(this).find("a").toggleClass("active");
	                    $(".state-budget-details").toggle();
	                });
	            },
	            masonry: function masonry(method) {
	                $(window).on("load", function () {
	                    var $container = $('[data-layout="masonry"]');
	
	                    if ($container.length > 0 && method === "destroy") {
	                        $container.masonry().masonry("destroy");
	                    } else if ($container.length > 0) {
	                        if (typeof imagesLoaded === "function") {
	                            imagesLoaded($container, function () {
	                                var msnry = new Masonry($container[0], {
	                                    itemSelector: ".masonry-item"
	                                });
	                            });
	                        }
	                    }
	                });
	            },
	            openModal: function openModal() {
	                $("[data-connect]").on("click", function () {
	                    var connectId = $(this).attr("data-connect");
	                    $(".main-container").css({
	                        height: "100%",
	                        overflow: "hidden"
	                    });
	                    $("#" + connectId).addClass("active");
	                });
	            },
	            closeModal: function closeModal() {
	                $("[data-modal-close]").on("click", function () {
	                    $(".main-container").css({
	                        height: "auto",
	                        overflow: "visible"
	                    });
	                    $(this).closest(".view-modal").removeClass("active");
	                });
	            },
	            // Toggle display element from data-attribute
	            dataToggle: function dataToggle() {
	                $("[data-toggle]").each(function (index, el) {
	                    // filter tabs
	                    var isTabFilters = $(el).hasClass("tabs-listing-filter-trigger");
	
	                    var $trigger = $(el),
	                        $initialText = $trigger.data("initial-text"),
	                        $activeText = $trigger.data("active-text"),
	                        $target = $($trigger.data("toggle")),
	                        $toggler = function $toggler() {
	                        $trigger.toggleClass("active");
	                        $target.toggleClass("open");
	
	                        // tabs
	                        if (isTabFilters && !$trigger.hasClass("active")) {
	                            localStorage.setItem("tab_filters_open", false);
	                        } else {
	                            localStorage.setItem("tab_filters_open", true);
	                        }
	
	                        if ($trigger.hasClass("active")) {
	                            if ($activeText) {
	                                $trigger.text($activeText);
	                            }
	                        } else if ($initialText) {
	                            $trigger.text($initialText);
	                        }
	                        $trigger.attr("aria-expanded", $trigger.hasClass("active") ? "true" : "false");
	                    };
	
	                    $(el).on("click", function (e) {
	                        e.preventDefault();
	                        $toggler();
	                    }).on("keydown", function (e) {
	                        if (e.which === 13) {
	                            e.preventDefault();
	                            $toggler();
	                        }
	                    });
	                    // filter tabs
	                    if (isTabFilters && $(el).hasClass("active") && localStorage.getItem("tab_filters_open") == "false") {
	                        $(el).trigger("click");
	                    }
	                });
	            },
	            // Toggle tabs
	            dataTabs: function dataTabs() {
	                $("[data-tab-toggle]").each(function (index, el) {
	
	                    var $trigger = $(el),
	                        $tabset = $trigger.data("tab-set"),
	                        $target = $($trigger.data("tab-toggle")),
	                        $toggler = function $toggler() {
	                        if ($trigger.hasClass("active") && $trigger.data("can-toggle-close")) {
	                            $trigger.removeClass("active");
	                            $target.removeClass("open");
	                            $trigger.attr("aria-expanded", "false");
	                            openTab = false;
	                        } else if (!$trigger.hasClass("active")) {
	                            $($('[data-tab-set="' + $tabset + '"][data-tab-toggle].active').data("tab-toggle")).removeClass("open");
	                            $('[data-tab-set="' + $tabset + '"][data-tab-toggle].active').attr("aria-expanded", "false").removeClass("active");
	
	                            $trigger.addClass("active");
	                            $target.addClass("open");
	                            $trigger.attr("aria-expanded", "true");
	                            openTab = true;
	                        }
	                    };
	
	                    $(el).on("click", function (e) {
	                        e.stopPropagation();
	                        e.preventDefault();
	                        $toggler();
	                    }).on("keydown", function (e) {
	                        if (e.which === 13) {
	                            $toggler();
	                            e.preventDefault();
	                        }
	                    });
	                });
	
	                // Close open tab when clicking anywhere outside the active tab area
	                $("html").on("click", function (e) {
	                    if (openTab && !$(e.target).closest("[data-tab-area]").length) {
	                        $("[data-tab-toggle].active:visible").triggerHandler("click");
	                        openTab = false;
	                    }
	                });
	            },
	            dataTabButtonList: function dataTabButtonList() {
	                $("[data-tab-button-list] button").on("click", function () {
	                    if (!$(this).hasClass("current")) {
	                        var $btn = $(this),
	                            $label = $btn.closest("[data-filter-container], [data-tab-area]").children("[data-tab-toggle]").children("[data-selected]"),
	                            $sibs = $btn.closest("li").siblings().children("button");
	
	                        $sibs.removeClass("current");
	                        $btn.addClass("current");
	                        $label.text($btn.text());
	                        $btn.trigger('dataTabButtonListChanged', $btn.parent().index());
	                    }
	                });
	            },
	            dataTabsShadow: function dataTabsShadow() {
	
	                $("[data-tab-has-shadow]").each(function () {
	
	                    var $select = $(this);
	                    var $ul = $select.next("[data-tab-is-shadow]");
	
	                    $select.children("option").each(function () {
	                        $ul.append('<li><button type="button" data-value="' + $(this).val() + '"' + ($(this).val() == $select.val() ? "class='current'" : "") + '>' + $(this).text() + '</button></li>');
	                    });
	
	                    // update dropdown when links selected
	                    $ul.bind("dataTabButtonListChanged", function (event, index) {
	                        //do stuff here
	                        $select.children('option:eq(' + index + ')').prop('selected', true);
	                    });
	
	                    // update list when dropdown selected
	                    // $select.change(function() {
	                    //     var e =  $('option:selected', this).index();
	                    //     $ul
	                    //     $('ul.list > li').removeClass('active');
	                    //     $('ul.list > li:eq('+e+')').addClass('active');
	                    // });
	                });
	            },
	            // Hide display element from data-attribute
	            dataHide: function dataHide() {
	                $("[data-hide]").on("click", function () {
	                    var $target = $($(this).data("hide"));
	
	                    $target.removeClass("open");
	                });
	            },
	            // Click trigger-element from data-attribute
	            dataTriggerClick: function dataTriggerClick() {
	                $("[data-trigger-click]").on("click", function () {
	                    var $trigger = $(this),
	                        $target = $($trigger.data("trigger-click")),
	                        $initialText = $trigger.data("initial-text"),
	                        $activeText = $trigger.data("active-text");
	
	                    if ($trigger.hasClass("active")) {
	                        $trigger.removeClass("active");
	                        $target.each(function (index, el) {
	                            if ($(el).hasClass("active")) {
	                                $(el).trigger("click");
	                            }
	                        });
	                    } else {
	                        $trigger.addClass("active");
	                        $target.each(function (index, el) {
	                            if (!$(el).hasClass("active")) {
	                                $(el).trigger("click");
	                            }
	                        });
	                    }
	
	                    $activeText && $trigger.hasClass("active") ? $trigger.text($activeText) : $trigger.text($initialText);
	                });
	            },
	            toggleLanguage: function toggleLanguage(e) {
	                $("[data-language-btn]").on("click", function (e) {
	                    e.preventDefault();
	                    var $trigger = $("[data-language-btn]"),
	                        $target = $("[data-language-selector]");
	                    $trigger.toggleClass("active");
	                    $trigger.attr("aria-expanded", $trigger.hasClass("active") ? "true" : "false");
	                    $target.slideToggle("fast");
	                });
	            },
	            toggleSocial: function toggleSocial(e) {
	                $("a[data-social-btn]").on("click", window.stortinget.initializeSocialButton);
	            },
	            toggleSearch: function toggleSearch(e) {
	                // console.log(e.target);
	                var $container = $('[data-target="search-container"]');
	                var $curtain = $(".header-curtain");
	                var $header = $("[data-header]");
	                var $trigger = $("[data-search-btn]");
	
	                // if (context === 'small') {
	                $('[data-toggler="search-container"], .close-search-container').on("click", function (e) {
	                    e.preventDefault();
	                    e.stopImmediatePropagation();
	
	                    // check if mobile nav open
	                    if ($(".main-container").hasClass("mobile-nav-open")) {
	                        // close nav
	                        $("[data-toggle-nav-primary]").trigger("click");
	                    }
	
	                    // check if desktop open
	                    if ($(".nav-primary > ul > li").hasClass("active")) {
	                        $(".nav-primary > ul > li.active a").trigger("click");
	                    }
	
	                    $('[data-toggler="search-container"]').toggleClass("active");
	
	                    $trigger.attr("aria-expanded", $trigger.hasClass("active") ? "true" : "false");
	
	                    $header.toggleClass("open");
	                    $(".main-container").toggleClass("mobile-search-open");
	                    $("body").toggleClass("mobile-no-scroll");
	                    app.handleBodyScroll();
	
	                    $curtain.css({
	                        top: $header.outerHeight(),
	                        height: $(".header").hasClass("open") ? 240 : 0
	                    });
	
	                    if (!$container.hasClass("open")) {
	                        window.setTimeout(function () {
	                            $container.toggleClass("open");
	                            //$('.search-container').toggleClass('active');
	                            $(".search-container").height("199px");
	                            $("#searchformquery").focus();
	                        }, 300);
	                    } else {
	                        $(".search-container").height("auto");
	                        $container.toggleClass("open");
	                    }
	
	                    if ($(e.currentTarget).hasClass("close-search-container")) {
	                        $('[data-toggler="search-container"]').focus();
	                    }
	                });
	
	                // }
	            },
	
	            handleBodyScroll: function handleBodyScroll() {
	                // Lock body
	                if ($("body").hasClass("mobile-no-scroll")) {
	                    if (window.pageYOffset) {
	                        app.scrollTop = window.pageYOffset;
	                        app.$wrap.css({
	                            top: -app.scrollTop,
	                            position: "fixed"
	                        });
	                    }
	
	                    app.$htmlBody.css({
	                        height: "100%",
	                        overflow: "hidden"
	                    });
	                } else {
	                    app.$htmlBody.css({
	                        height: "",
	                        overflow: ""
	                    });
	
	                    app.$wrap.css({
	                        top: "",
	                        position: ""
	                    });
	
	                    window.scrollTo(0, app.scrollTop);
	                    window.setTimeout(function () {
	                        app.scrollTop = null;
	                    }, 0);
	                }
	            },
	
	            toggleNavPrimary: function toggleNavPrimary(e) {
	                $("[data-toggle-nav-primary]").on("click", function (e) {
	                    e.preventDefault();
	
	                    var $curtain = $(".header-curtain");
	                    var $header = $("[data-header]");
	                    var $menuBtn = $(this);
	
	                    // check if mobile search open
	                    if ($(".main-container").hasClass("mobile-search-open")) {
	                        // close nav
	                        $('[data-toggler="search-container"]').trigger("click");
	                    }
	
	                    $(".main-container").toggleClass("mobile-nav-open");
	                    $("body").toggleClass("mobile-no-scroll");
	                    app.handleBodyScroll();
	
	                    // Container
	                    $("[data-nav-primary]").toggleClass("active");
	                    $menuBtn.attr("aria-expanded", $("[data-nav-primary]").hasClass("active") ? "true" : "false");
	                    // Button
	                    $("[data-toggle-nav-primary]").toggleClass("active");
	
	                    // if closing, minimize curtain
	                    if (!$(".main-container").hasClass("mobile-nav-open")) {
	                        $curtain.css({
	                            top: $header.outerHeight(),
	                            height: 0
	                        });
	                    }
	                });
	            },
	            navPrimary: function navPrimary(context) {
	                // small / large not working
	                var index = 0;
	                $(".sub-title").each(function (e) {
	                    if ($(this)[0].hasAttribute("aria-expanded")) {
	                        $(this).attr("aria-controls", "sub-item" + index).next(".level-3").attr("id", "sub-item" + index);
	                        index++;
	                    }
	                });
	                if (context === "small") {
	                    $('[data-nav-primary] a.topMenuItem').on("click", function (e) {
	                        e.preventDefault();
	
	                        // check if mobile search open
	                        if ($(".main-container").hasClass("mobile-search-open")) {
	                            // close nav
	                            $('[data-toggler="search-container"]').trigger("click");
	                        }
	
	                        // $(this).toggleClass('active');
	
	                        if ($(this).next().find(".level-2").length) {
	                            $(this).next().find(".level-2").toggleClass("open");
	                            $(this).next().find(".section-link").toggleClass("open");
	                        } else if ($(this).next(".level-3").length) {
	                            $(this).next(".level-3").toggleClass("open");
	                        }
	                    });
	
	                    $("[data-nav-primary] .sub-title").on("click", function () {
	                        $(this).toggleClass("active");
	                        if ($(this)[0].hasAttribute("aria-expanded")) {
	                            $(this).attr("aria-expanded", $(this).hasClass("active") ? "true" : "false");
	                        }
	                        $(this).next().toggleClass("open");
	                    }).on("keydown", function (e) {
	                        if (e.which === 13) {
	                            $(this).trigger("click");
	                        }
	                    });
	                } else if (context === "large") {
	
	                    $('.level-1 a.topMenuItem').on("click", function (e) {
	                        e.preventDefault();
	                        var $anchor = $(this),
	                            $li = $anchor.parent(),
	                            $colContainer = $anchor.next(".col-container"),
	                            $header = $("[data-header]"),
	                            $curtain = $("[data-nav-primary-curtain]");
	
	                        // $li.siblings().removeClass('active');
	
	                        if ($(".header").hasClass("open") && !$colContainer.hasClass("open") && $colContainer.length) {
	                            $(".col-container").removeClass("open");
	                            $colContainer.toggleClass("open");
	
	                            if (scope === "large") {
	                                $(".level-1 li").removeClass("active");
	                                $('.level-1 a.topMenuItem').removeClass("active");
	                            }
	                            $li.toggleClass("active");
	                            $anchor.toggleClass("active");
	                            $curtain.css({
	                                height: $(".header").hasClass("open") ? $colContainer.outerHeight() + 1 : 0
	                            });
	                        } else if ($colContainer.length) {
	                            $colContainer.toggleClass("open");
	                            $(".header").toggleClass("open");
	                            $li.toggleClass("active");
	                            $anchor.toggleClass("active");
	                            $anchor.attr("aria-expanded", $li.hasClass("active") ? "true" : "false");
	                            $curtain.css({
	                                top: $header.outerHeight(),
	                                height: $(".header").hasClass("open") ? $colContainer.outerHeight() + 1 : 0
	                            });
	                        } else {
	                            $(".col-container").removeClass("open");
	                            $(".header").removeClass("open");
	                            $curtain.css({
	                                height: 0
	                            });
	                        }
	
	                        //Disable tabbing to all close buttons
	                        $(".close-wrapper").find("button").each(function (e) {
	                            $(this).prop("tabindex", -1);
	                        });
	
	                        if ($colContainer.hasClass("open")) {
	                            $colContainer.find(".close-wrapper > .close-menu").each(function (e) {
	                                $(this).prop("tabindex", 0);
	                            });
	                        }
	                    });
	
	                    // Close menu dropdowns with escape-key
	                    $("[data-nav-primary] *").on("keydown", function (e) {
	                        if (e.which === 27) {
	                            // check if mobile nav open
	                            if ($(".main-container").hasClass("mobile-nav-open")) {
	                                // close nav
	                                $("[data-toggle-nav-primary]").trigger("click");
	                            }
	
	                            // check if desktop open
	                            if ($(".nav-primary > ul > li").hasClass("active")) {
	                                $(".nav-primary > ul > li.active a").trigger("click");
	                            }
	
	                            $(this).closest(".col-container").prev().focus();
	                        }
	                    });
	
	                    $("[data-nav-primary] .close-menu").on("click", function (e) {
	                        // check if mobile nav open
	                        if ($(".main-container").hasClass("mobile-nav-open")) {
	                            // close nav
	                            $("[data-toggle-nav-primary]").trigger("click");
	                        }
	
	                        // check if desktop open
	                        if ($(".nav-primary > ul > li").hasClass("active")) {
	                            $(".nav-primary > ul > li.active a")[0].click();
	                        }
	                        $(this).closest(".col-container").prev().focus();
	                    });
	                }
	
	                // Close menu on overlay click
	                $(".content-container").on("click", function () {
	                    // check if mobile nav open
	                    if ($(".main-container").hasClass("mobile-nav-open")) {
	                        // close nav
	                        $("[data-toggle-nav-primary]").trigger("click");
	                    }
	
	                    // check if desktop open
	                    if ($(".nav-primary > ul > li").hasClass("active")) {
	                        $(".nav-primary > ul > li.active a").trigger("click");
	                    }
	
	                    // check if mobile search open
	                    if ($(".main-container").hasClass("mobile-search-open")) {
	                        // close nav
	                        $('[data-toggler="search-container"]').trigger("click");
	                    }
	                });
	
	                window.setTimeout(function () {
	                    if (scope === "large") {
	                        $(".nav-primary .level-2 .sub-title").removeAttr("tabindex");
	                    } else {
	                        $(".nav-primary .level-2 .sub-title").attr("tabindex", "0");
	                    }
	                }, 300);
	            },
	            scopeChanged: function scopeChanged() {
	                // Reset primary nav and search panels on scope change
	                $(".header-curtain").removeAttr("style");
	
	                if ($(".main-container").hasClass("mobile-nav-open")) {
	                    $("[data-toggle-nav-primary]").trigger("click");
	                }
	                $(".nav-primary, .nav-primary .level-1 li, .nav-primary > ul > li.active, .nav-primary > ul > li > a.active").removeClass("active");
	                $(".header, .col-container, .nav-primary .section-link, .nav-primary .level-1, .nav-primary .level-2").removeClass("open");
	                $(".main-container").removeClass("mobile-search-open");
	                $("body").removeClass("mobile-no-scroll");
	                app.handleBodyScroll();
	
	                $(".search-container").removeClass("open").removeAttr("style");
	                $(".toggle-search").removeClass("active");
	            },
	            zoomArticleImage: function zoomArticleImage() {
	                $(".article-content-image").each(function (index, el) {
	                    $(el).find("img").on("click", function (e) {
	                        $(el).toggleClass("zoom");
	                        e.preventDefault();
	                    });
	                });
	            },
	            imageCaptionWidth: function imageCaptionWidth() {
	                $(window).on("load resize", function () {
	                    // Article image in paragraph
	                    $(".article-content .imagetext").removeAttr("style");
	                    $(".article-content p > img").each(function (index, el) {
	                        var $nextiscaption = $(el).parent().next();
	                        if ($(el).width() < $(el).parent().width() && $nextiscaption.hasClass("imagetext")) {
	                            $nextiscaption.outerWidth($(el).width());
	                        }
	
	                        $nextiscaption.show();
	                    });
	
	                    // Article Main image
	                    $(".article-mainimage > figure > img").each(function (index, el) {
	                        var $nextiscaption = $(el).parent().children("figcaption");
	                        if ($(el).width() < $(el).parent().width()) {
	                            $nextiscaption.outerWidth($(el).width());
	                        } else {
	                            $nextiscaption.width("auto");
	                        }
	                    });
	
	                    // Article Content Image
	                    $(".article-content-image > figure > img").each(function (index, el) {
	                        var $nextiscaption = $(el).parent().children("figcaption");
	                        if ($(el).width() < $(el).parent().width()) {
	                            $nextiscaption.outerWidth($(el).width());
	                        } else {
	                            $nextiscaption.width("auto");
	                        }
	                    });
	                });
	
	                $(window).on("load", function () {
	                    setTimeout(function () {
	                        $(".imagetext").show();
	                    }, 200);
	                });
	            },
	            caseScroll: function caseScroll() {
	                $(".case-step-links a, a.case-overview-internal-link").on("click", function (e) {
	                    e.preventDefault();
	                    var id = $(this).attr("href").substr(1, $(this).attr("href").length),
	                        scrollToId = $("#" + id);
	                    if (scrollToId.length) {
	                        $("body, html").animate({
	                            scrollTop: scrollToId.offset().top
	                        }, 500);
	                    }
	                });
	            },
	            customFileUpload: function customFileUpload() {
	                $("[data-file-upload-id]").each(function (index, el) {
	                    var fuid = $(el).data("file-upload-id");
	
	                    $(el).wrap('<div class="custom-file-upload"></div>').before('<input placeholder="' + $(el).data("txt-no-file-selected") + '" class="fake-upload-field" disabled="disabled" data-fake-upload-field="' + fuid + '"><button type="button" tabindex="-1" class="button submit upload" data-file-upload-button="' + fuid + '">' + $(el).data("txt-select-file") + "</button>").on("change", function () {
	                        var file = this.value,
	                            result = file.replace(/([^\\]*\\)*/, "");
	                        $('[data-fake-upload-field="' + fuid + '"]').attr("value", result);
	                    }).on("focus", function () {
	                        $('[data-file-upload-button="' + fuid + '"]').addClass("focused");
	                    }).on("blur", function () {
	                        $('[data-file-upload-button="' + fuid + '"]').removeClass("focused");
	                    });
	                });
	            },
	            accessifly: function accessifly() {
	                $("[data-listing-filters-trigger]").each(function (index, el) {
	                    $(el).attr("tabindex", "0");
	                });
	            },
	            fullVideoPlayer: function fullVideoPlayer() {
	                var $fullscreenplayer = $(".fullscreen #playerVideo"),
	                    $parent = $("#divPlayerContainer"),
	                    $parentH = $parent.height(),
	                    $parentR = $parentH / $parent.width() * 100;
	
	                if ($fullscreenplayer) {
	                    if ($parentR < 56.25) {
	                        $fullscreenplayer.css({
	                            "padding-bottom": $parentH * 100 / $parent.width() + "%"
	                        });
	                    } else {
	                        $fullscreenplayer.css({
	                            "padding-bottom": "56.25%"
	                        });
	                    }
	                } else {
	                    $fullscreenplayer.removeAttr("style");
	                }
	            },
	            fullVideoPlayerAdaption: function fullVideoPlayerAdaption() {
	                $(window).on("resize", function () {
	                    if ($(".player-wrapper").length) {
	                        app.fullVideoPlayer();
	                    }
	                });
	                $("#btnFullscreen").on("click", function () {
	                    if ($(".player-wrapper").length && !$(".player-wrapper").hasClass("fullscreen")) {
	                        $("#playerVideo").removeAttr("style");
	                    } else {
	                        app.fullVideoPlayer();
	                    }
	                });
	                $(document).on("keydown", function (e) {
	                    if ($(".player-wrapper").length && e.which === 27) {
	                        $("#playerVideo").removeAttr("style");
	                    }
	                });
	            },
	            wrapVideoIframe: function wrapVideoIframe() {
	                $("iframe[src*=youtube]").each(function (index, el) {
	                    var $vid = $(el);
	                    if (!$vid.parent().hasClass("video-embed-wrapper")) {
	                        $vid.wrap('<div class="video-embed-wrapper"></div>');
	                    }
	                });
	                $("iframe[src*=qbrick]").each(function (index, el) {
	                    var $vid = $(el);
	                    if (!$vid.parent().hasClass("video-embed-wrapper")) {
	                        $vid.wrap('<div class="video-embed-wrapper"></div>');
	                    }
	                });
	            },
	            greyboxAlignHeight: function greyboxAlignHeight() {
	                $(window).on("load resize", function () {
	                    $("[data-align-blocks-height]").delay(100).each(function (index, el) {
	                        //console.log("oo");
	                        var $list = $(el),
	                            $items = $list.find(".columns");
	
	                        $list.find(".columns > .block").css("height", "auto");
	
	                        if (scope !== "small") {
	                            var $perRow = Math.floor($list.width() / $items.width());
	
	                            if ($perRow == null || $perRow < 2) {
	                                return true;
	                            }
	
	                            for (var i = 0, j = $items.length; i < j; i += $perRow) {
	                                var $height = 0,
	                                    $row = $items.slice(i, i + $perRow);
	
	                                $row.each(function (index, elem) {
	                                    var $itemHeight = parseInt($(elem).find("> .block").outerHeight());
	
	                                    if ($itemHeight > $height) {
	                                        $height = $itemHeight;
	                                    }
	                                });
	
	                                $row.find("> .block").css("height", $height);
	                            }
	                        }
	                    });
	                });
	            },
	            setLanguageCookieOnSelect: function setLanguageCookieOnSelect() {
	                var languageSelectors = $("[data-click-language-selector]");
	                languageSelectors.on("click", function (e) {
	                    var language = $(this).data("language");
	                    $.cookie("language_selected", language, {
	                        expires: 365,
	                        path: "/"
	                    });
	                });
	            },
	            tableWrap: function tableWrap() {
	                $(".article-content table").tablewrapper({
	                    textclosed: "Vis tabellen under i full bredde",
	                    textopen: "Skjul overflytende tabell innhold"
	                });
	            },
	            tableWrapBigdoc: function tableWrapBigdoc() {
	                if ($(".bigdoc-content table").length > 0) {
	                    $(".bigdoc-content table").tablewrapperBigdoc({
	                        textclosed: "Vis tabellen i full bredde"
	                    });
	                }
	            },
	            copyStringToClipboard: function copyStringToClipboard() {
	                if ($("[data-copy-string-to-clipboard]").length > 0) {
	                    $("[data-copy-string-to-clipboard]").on("click", function (e) {
	                        e.preventDefault();
	                        var targetDataAttr = $(this).attr("data-copy-string-to-clipboard");
	                        var $copyTextarea = $("[" + targetDataAttr + "]");
	
	                        $copyTextarea.focus();
	                        $copyTextarea.select();
	                        try {
	                            var successful = document.execCommand('copy');
	                            var msg = successful ? 'successful' : 'unsuccessful';
	                            $("[data-copy-msg]").fadeIn();
	                            setTimeout(function () {
	                                $("[data-copy-msg]").fadeOut();
	                            }, 1500);
	                        } catch (err) {
	                            //console.log('Oops, unable to copy');
	                        }
	                    });
	                }
	            },
	            scrollPageIfMobileAndAnchorLink: function scrollPageIfMobileAndAnchorLink() {
	                if (!$("[data-bigdoc-nav-wrapper]").length) {
	                    var $header = $("header.header");
	                    var positionProperty = $header.css("position");
	                    if (positionProperty !== "fixed") return;
	                    var hash = window.location.hash;
	                    if (!hash) return;
	                    var target = $(hash),
	                        headerHeight = $header.height() + 5; // Get fixed header height
	                    target = target.length ? target : $(document.getElementById(hash.substr(1)));
	                    if (target.length) {
	                        $("html,body").animate({
	                            scrollTop: target.offset().top - headerHeight
	                        }, 500);
	                    }
	                }
	            },
	            addHashScrollToHrefsIfStickyHeader: function addHashScrollToHrefsIfStickyHeader() {
	                if (!$("[data-bigdoc-nav-wrapper]").length) {
	                    $('a[href*="#"]:not([href="#"])').click(function (e) {
	                        var $header = $("header.header");
	                        var positionProperty = $header.css("position");
	                        if (positionProperty !== "fixed") return true;
	                        if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") || location.hostname == this.hostname) {
	                            var target = $(this.hash),
	                                headerHeight = $header.height() + 5; // Get fixed header height
	
	                            target = target.length ? target : $(document.getElementById(this.hash.substr(1)));
	
	                            if (target.length) {
	                                $("html,body").animate({
	                                    scrollTop: target.offset().top - headerHeight
	                                }, 500);
	                            }
	                        }
	                    });
	                }
	            },
	            addHashToShareLinks: function addHashToShareLinks() {
	                $("[data-some-share-link]").each(function (index, element) {
	                    var $elem = $(element);
	                    $elem.on("click", function (e) {
	                        var url = $elem.attr("href");
	                        var hashIndex = url.indexOf("%23");
	                        if (hashIndex > -1) url = url.substr(0, hashIndex);
	                        var hash = window.location.hash.replace("#", "%23");
	                        $elem.attr("href", url + hash);
	                    });
	                });
	            }
	        };
	    }();
	
	    (function () {
	        "use strict";
	
	        app.init();
	        window.fullVideoPlayer = app.fullVideoPlayer;
	        //window.reloadMasonry = app.masonry;
	    })();
	});
	
	// if(__LOCAL__) {
	// 	// Inject development script
	// 	var dev_script = document.createElement('script');
	// 	dev_script.setAttribute('src','public/js/dev.js');
	// 	dev_script.async = false;
	// 	document.body.appendChild(dev_script);
	// }

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.min.js